import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, IconButton, Tooltip } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";

const CustomTable = ({ columns, data, loading = false }) => {
  if (!data) {
    data = [];
  }

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading,
    },

    initialState: { density: "compact" },

    // ✅ Enable Features
    enableColumnFilters: true,
    enableGlobalFilter: true,
    enableSorting: true,

    enableRowSelection: false,
    columnFilterDisplayMode: "popover", // or "subheader"
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#124178",
        fontWeight: "normal",
        color: "#ffffff",
      }),
    },

    renderRowActions: ({ cell, row, table }) => [
      <Box display="flex" flexDirection="row" alignItems="center" key={row.id}>
        <Tooltip title="Edit User">
          <IconButton>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton>
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>,
    ],
  });

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  );
};

export default CustomTable;

// import {
//   MaterialReactTable,
//   useMaterialReactTable,
// } from "material-react-table";
// import { Box, Button, IconButton, Tooltip } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { mkConfig, generateCsv, download } from "export-to-csv";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import EditIcon from "@mui/icons-material/Edit";
// import { Delete } from "@mui/icons-material";

// const csvConfig = mkConfig({
//   fieldSeparator: ",",
//   decimalSeparator: ".",
//   useKeysAsHeaders: true,
// });

// const CustomTable = ({
//   columns,
//   data,
//   showRowAction = false,
//   // DataForExportAll,
//   loading = false,
// }) => {
//   // this is only for month and year selector in partner Invoice

//   // end

//   if (!data) {
//     data = [];
//   }
//   // if (!DataForExportAll) {
//   //   DataForExportAll = data;
//   // }

//   // const handleExportRows = (rows) => {
//   //   const rowData = rows?.map((row) => row.original);
//   //   const csv = generateCsv(csvConfig)(rowData);
//   //   download(csvConfig)(csv);
//   // };

//   // const handleExportData = () => {
//   //   // const csv = generateCsv(csvConfig)(data);
//   //   const csv = generateCsv(csvConfig)(DataForExportAll);
//   //   download(csvConfig)(csv);
//   // };

//   const table = useMaterialReactTable({
//     columns,
//     data,
//     state: {
//       isLoading: loading, // <--- Use this built-in prop for loading state
//     },

//     initialState: { density: "compact" },
//     enableRowSelection: false,
//     columnFilterDisplayMode: "popover",
//     paginationDisplayMode: "pages",
//     positionToolbarAlertBanner: "bottom",
//     // enableRowActions: true,
//     // enableRowActions: showRowAction,
//     // positionActionsColumn: "last",
//     enableGlobalFilter: true,
//     maxSize: 100,

//     muiTableHeadCellProps: {
//       sx: () => ({
//         background: "#124178",
//         fontWeight: "normal",
//         color: "#ffffff",
//       }),
//     },

//     // renderRowActions: ({ cell, row, table }) => [
//     //   // Add your row actions here
//     // ],

//     renderRowActions: ({ cell, row, table }) => [
//       <>
//         <Box display="flex" flexDirection="row" alignItems="center">
//           <Tooltip title="Edit User">
//             <IconButton>
//               {/* <IconButton onClick={() => handleOpen(row.original)}> */}
//               <EditIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Delete">
//             <IconButton>
//               {/* <IconButton onClick={() => handleBlockUser(row.original)}> */}
//               <Delete />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       </>,
//     ],
//     // renderTopToolbarCustomActions: ({ table }) => (
//     //   <Box
//     //     sx={{
//     //       display: "flex",
//     //       gap: "16px",
//     //       padding: "8px",
//     //       flexWrap: "wrap",
//     //     }}
//     //   >
//     //     <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
//     //       Export All Data
//     //     </Button>

//     //     <Button
//     //       disabled={
//     //         !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
//     //       }
//     //       onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
//     //       startIcon={<FileDownloadIcon />}
//     //     >
//     //       Export Selected Rows
//     //     </Button>
//     //   </Box>
//     // ),
//   });

//   return (
//     <>
//       <MaterialReactTable table={table} />
//     </>
//   );
// };

// export default CustomTable;
